// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".p-button-sm[data-v-044d17fd]{height:35px;width:35px;font-size:.875rem;padding:.7rem}.p-component[data-v-044d17fd]:disabled,.p-disabled[data-v-044d17fd]{opacity:.8}.p-dropdown[data-v-044d17fd]{min-width:200px}", ""]);
// Exports
module.exports = exports;
